// Leaving the app entirely, for a payment provider's own page. Its own module
// so nothing has to replace the browser's location to watch it happen.
export function leaveFor(url: string): void {
  window.location.assign(url);
}
